import { createContext, useContext } from 'react';

export const StoreContext = createContext();
export const useStore = () => useContext(StoreContext);

export const HandlersContext = createContext();
export const useHandlers = () => useContext(HandlersContext);

export const ValueContext = createContext();
export const useValueContext = () => useContext(ValueContext);
